import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import "./AppGuide.scss";

import imgDashboard from "../../assets/images/app-guide/dashboard-overview.jpg";
import imgDashboardDark from "../../assets/images/app-guide/home-dark.jpg";
import imgHospitalSalary from "../../assets/images/app-guide/hospital-salary-calculator.jpg";
import imgHospitalSalaryDark from "../../assets/images/app-guide/hospital-salary-dark.jpg";
import imgPaycheck from "../../assets/images/app-guide/paycheck-calculator.jpg";
import imgPaycheckDark from "../../assets/images/app-guide/paycheck-dark.jpg";
import imgMortgage from "../../assets/images/app-guide/mortgage-calculator.jpg";
import imgMortgageDark from "../../assets/images/app-guide/mortgage-calculator-dark.jpg";
import imgLiveHereWorkThere from "../../assets/images/app-guide/live-here-work-there.jpg";
import imgLiveHereWorkThereDark from "../../assets/images/app-guide/comparision.jpg";
import imgSearchCities from "../../assets/images/app-guide/search-cities.jpg";
import imgSearchCitiesDark from "../../assets/images/app-guide/search-list-dark.jpg";
import imgCityDetail from "../../assets/images/app-guide/city-detail.jpg";
import imgCityDetailDark from "../../assets/images/app-guide/search-deatil-dark.jpg";
import imgJobDetail from "../../assets/images/app-guide/job-detail.jpg";
import imgJobDetailDark from "../../assets/images/app-guide/job-detail-dark.jpg";
import imgJobsListing from "../../assets/images/app-guide/jobs-listing.jpg";
import imgJobsListingDark from "../../assets/images/app-guide/job-list-dark.jpg";
import imgCommunity from "../../assets/images/app-guide/community.png";
import imgCommunityDark from "../../assets/images/app-guide/community-dark.jpg";
import imgCreatePost from "../../assets/images/app-guide/create-community-post.png";
import imgCreatePostDark from "../../assets/images/app-guide/create-post-dark.jpg";
import imgBlog from "../../assets/images/app-guide/blog.jpg";
import imgBlogDark from "../../assets/images/app-guide/blog-dark.jpg";
import imgProfile from "../../assets/images/app-guide/profile.jpg";
import imgProfileDark from "../../assets/images/app-guide/profile-dark.jpg";
import imgAnnualBilling from "../../assets/images/app-guide/annual-billing.jpg";
import imgAnnualBillingDark from "../../assets/images/app-guide/subscription-dark.jpg";
import imgMonthlyBilling from "../../assets/images/app-guide/monthly-billing.jpg";
import imgMonthlyBillingDark from "../../assets/images/app-guide/subscribtion-monthly-dark.jpg";
import imgContactUs from "../../assets/images/app-guide/contact-us.png";
import imgContactUsDark from "../../assets/images/app-guide/contact-us-dark.jpg";
import imgReferral from "../../assets/images/app-guide/referral.jpg";
import imgReferralDark from "../../assets/images/app-guide/rafferal-dark.jpg";
import imgChangePassword from "../../assets/images/app-guide/change-password.png";
import imgChangePasswordDark from "../../assets/images/app-guide/change-password-dark.jpg";
import imgMessages from "../../assets/images/app-guide/messages.png";
import imgMessagesDark from "../../assets/images/app-guide/massaging-dark.jpg";
import usePageTracking from "../../hooks/usePageTracking";
import {
  activityEnd,
  activityStart,
} from "../../redux/slices/trackActivitySlice";
import { useDispatch } from "react-redux";
// Intrinsic pixel dimensions for every screenshot, so the <img> below can
// carry width/height attributes. That lets the browser reserve the right
// aspect-ratio box before the (large) image finishes loading — without it,
// images pop in and shove everything below them down (layout shift), which
// was throwing off the scroll-to-top when switching articles.
const IMAGE_DIMS = new Map([
  [imgDashboard, [1366, 1372]],
  [imgDashboardDark, [1366, 1484]],
  [imgHospitalSalary, [1366, 1664]],
  [imgHospitalSalaryDark, [1366, 1277]],
  [imgPaycheck, [1366, 2205]],
  [imgPaycheckDark, [1366, 2119]],
  [imgMortgage, [1366, 1308]],
  [imgMortgageDark, [1366, 1209]],
  [imgLiveHereWorkThere, [1366, 903]],
  [imgLiveHereWorkThereDark, [1366, 904]],
  [imgSearchCities, [1366, 1144]],
  [imgSearchCitiesDark, [1366, 813]],
  [imgCityDetail, [1366, 3406]],
  [imgCityDetailDark, [1319, 3859]],
  [imgJobDetail, [1366, 2006]],
  [imgJobDetailDark, [1366, 1965]],
  [imgJobsListing, [1366, 1611]],
  [imgJobsListingDark, [1366, 1181]],
  [imgCommunity, [1366, 1905]],
  [imgCommunityDark, [1366, 2654]],
  [imgCreatePost, [1366, 641]],
  [imgCreatePostDark, [1366, 641]],
  [imgBlog, [1366, 1315]],
  [imgBlogDark, [1366, 731]],
  [imgProfile, [1366, 1773]],
  [imgProfileDark, [1366, 2575]],
  [imgAnnualBilling, [1366, 1316]],
  [imgAnnualBillingDark, [1366, 1307]],
  [imgMonthlyBilling, [1366, 830]],
  [imgMonthlyBillingDark, [1366, 829]],
  [imgContactUs, [1366, 641]],
  [imgContactUsDark, [1366, 654]],
  [imgReferral, [1366, 922]],
  [imgReferralDark, [1366, 924]],
  [imgChangePassword, [1366, 641]],
  [imgChangePasswordDark, [1366, 591]],
  [imgMessages, [1366, 641]],
  [imgMessagesDark, [1366, 641]],
]);

const imageDims = (src) => IMAGE_DIMS.get(src) || [1366, 700];

const KbIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
  </svg>
);
const ChevronIcon = ({ open }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      transform: `rotate(${open ? 180 : 0}deg)`,
      transition: "transform .2s",
      opacity: 0.65,
      flex: "none",
    }}
  >
    <path d="m6 9 6 6 6-6"></path>
  </svg>
);
const ArrowLeftIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 12H5M11 18l-6-6 6-6"></path>
  </svg>
);
const ArrowRightIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14M13 6l6 6-6 6"></path>
  </svg>
);
const TipIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 18h6M10 22h4"></path>
    <path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.2 1 2h6c0-.8.4-1.5 1-2A7 7 0 0 0 12 2z"></path>
  </svg>
);
const EmptyMediaIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="3"></rect>
    <circle cx="8.5" cy="8.5" r="1.6"></circle>
    <path d="m21 15-5-5L5 21"></path>
  </svg>
);
const MenuIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="4" y1="7" x2="20" y2="7"></line>
    <line x1="4" y1="12" x2="20" y2="12"></line>
    <line x1="4" y1="17" x2="20" y2="17"></line>
  </svg>
);
const CloseIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const CATS = [
  {
    id: "getting-started",
    name: "Home",
    items: [
      { id: "nav-dashboard", title: "Navigating the Dashboard" },
      { id: "profile-setup", title: "Setting Up Your Profile" },
      { id: "role-specialty", title: "Choosing Role & Specialty" },
      { id: "saving-cities", title: "Saving & Syncing Cities" },
    ],
  },
  {
    id: "salaries",
    name: "Salaries & Paychecks",
    items: [{ id: "salary-paycheck", title: "Salary & Paycheck Calculators" }],
  },
  {
    id: "mortgage",
    name: "Mortgage Calculator",
    items: [
      { id: "mortgage-how", title: "How the Calculator Works" },
      { id: "piti", title: "PITI Explained" },
      { id: "affordability", title: "Down Payment & Affordability" },
    ],
  },
  {
    id: "comparison",
    name: "Comparison",
    items: [
      { id: "compare-cities", title: "Comparing Cities Side by Side" },
      { id: "compare-metrics", title: "Which Metrics to Compare" },
    ],
  },
  {
    id: "jobs",
    name: "Jobs",
    items: [
      { id: "job-search", title: "Searching Jobs by Role" },
      { id: "job-alerts", title: "Setting Up Job Alerts" },
    ],
  },
  {
    id: "cities",
    name: "Search Cities",
    items: [
      { id: "city-filters", title: "Filters & Cost of Living" },
      { id: "city-grades", title: "Understanding City Grades" },
    ],
  },
  {
    id: "community",
    name: "Community",
    items: [
      { id: "join-forum", title: "Joining the Nurse Forum" },
      { id: "posting", title: "Posting & Etiquette" },
    ],
  },
  {
    id: "messages",
    name: "Messages",
    items: [{ id: "direct-messages", title: "Sending Direct Messages" }],
  },
  {
    id: "blogs",
    name: "Blogs",
    items: [{ id: "reading-blogs", title: "Reading & Following Blogs" }],
  },
  {
    id: "profile",
    name: "Profile",
    items: [
      { id: "profile-page", title: "Profile" },
      { id: "subscription", title: "Subscription" },
      { id: "contact-us", title: "Contact us" },
      { id: "referral", title: "Referral" },
      { id: "change-password", title: "Change password" },
    ],
  },
];

const ARTICLES = {
  "nav-dashboard": {
    cat: "getting-started",
    title: "Dashboard Overview",
    readTime: "4 min read",
    updated: "Jul 2026",
    image: imgDashboard,
    darkImage: imgDashboardDark,
    desc:
      "The Dashboard provides a complete snapshot of your nursing career opportunities, salary insights, and financial planning tools in one place. It helps you compare cities, discover jobs, evaluate housing affordability, and access community discussions without leaving the platform.",
    stepsTitle: "What’s on the Dashboard",
    steps: [
      {
        title: "City Spotlight",
        text:
          "Highlights a selected city and shows key financial information at a glance.",
        bullets: [
          {
            label: "Gross Salary",
            text: "Estimated annual earnings in the selected city.",
          },
          { label: "Taxes", text: "Estimated yearly tax deductions." },
          {
            label: "Monthly Leftover",
            text:
              "Expected remaining income after taxes and essential expenses.",
          },
          {
            label: "City Insights",
            text: "Population, climate, and healthcare facility information.",
          },
          { label: "View Details", text: "Opens a detailed city analysis." },
          {
            label: "Next City",
            text: "Browse alternative locations and compare opportunities.",
          },
        ],
        note:
          "Why it matters — quickly identify cities that offer the best balance between salary, living costs, and career growth.",
      },
      {
        title: "Saved Cities",
        text: "Bookmark locations you’re interested in and keep them close.",
        bullets: [
          "Save multiple cities for future comparison.",
          "View estimated monthly leftover income.",
          "Sync saved cities across devices.",
          "Manage and update your city list anytime.",
        ],
      },
      {
        title: "Nursing Job Opportunities",
        text:
          "Displays nursing positions relevant to your selected specialty and location.",
        bullets: [
          "Job Title",
          "Healthcare Organization",
          "Location",
          "Posting Date",
          "Estimated Monthly Earnings After Housing Costs",
        ],
        note:
          "Benefits — compare earning potential across different employers and regions to make informed career decisions.",
      },
      {
        title: "Homeownership Snapshot",
        text:
          "Helps you understand whether purchasing a home is financially realistic based on your income.",
        bullets: [
          "Median Home Price",
          "Estimated Down Payment",
          "Estimated Monthly Mortgage",
          "Percentage of Income Required for Housing",
        ],
        note:
          "Purpose — evaluate housing affordability before relocating to a new city.",
      },
      {
        title: "Community Discussions",
        text:
          "Connect with other healthcare professionals through community conversations.",
        bullets: [
          "Read industry-related discussions.",
          "Explore financial and career advice.",
          "Share experiences and ask questions.",
          "Engage with other nurses and healthcare professionals.",
        ],
      },
      {
        title: "Hospital Map",
        text:
          "An interactive map showing healthcare facilities within the selected region.",
        bullets: [
          "View nearby hospitals.",
          "Explore healthcare density in different areas.",
          "Analyze employment opportunities geographically.",
          "Open the full map for detailed exploration.",
        ],
        note:
          "Why use it — identify locations with strong healthcare infrastructure and greater job availability.",
      },
      {
        title: "Featured Tools",
        text:
          "Access specialized calculators and planning tools designed for healthcare professionals.",
        bullets: [
          {
            label: "Live Here, Work There",
            text:
              "Compare the financial impact of living in one city while working in another — commute costs, net take-home pay, housing differences and overall monthly savings.",
          },
          {
            label: "Hospital Salary Calculator",
            text:
              "Estimate salary ranges by position, experience, location and employer type.",
          },
          {
            label: "Mortgage Calculator",
            text:
              "Calculate monthly payments, down payment requirements, loan affordability and long-term housing costs.",
          },
        ],
      },
    ],
    tip:
      "The Dashboard combines salary analysis, city comparison, job discovery, housing insights, and community resources into a single workspace — helping healthcare professionals make smarter career and financial decisions.",
  },

  "profile-setup": {
    cat: "getting-started",
    title: "Setting Up Your Profile",
    readTime: "2 min read",
    updated: "Jul 2026",
    desc:
      "A complete profile makes every salary and mortgage number accurate. It takes about a minute.",
    dropLabel: "Drop a profile screen screenshot here",
    stepsTitle: "Set up in 3 steps",
    steps: [
      {
        title: "Open your account",
        text: "Tap your name in the top-right and choose Account.",
      },
      {
        title: "Add role & experience",
        text:
          "Pick your nursing role and years of experience — this drives every salary estimate.",
      },
      {
        title: "Set your home city",
        text:
          "Choose where you’re based so comparisons start somewhere meaningful.",
      },
    ],
    tip:
      "Update your role any time — the whole dashboard adjusts automatically.",
  },

  "role-specialty": {
    cat: "getting-started",
    title: "Choosing Role & Specialty",
    readTime: "1 min read",
    updated: "Jun 2026",
    desc:
      "Your role is the single biggest factor in salary and job accuracy, so pick it carefully.",
    dropLabel: "Drop a role selector screenshot here",
    stepsTitle: "Pick the right role",
    steps: [
      {
        title: "Search your title",
        text: "Type your role (e.g. CNM, RN, NP) and select the closest match.",
      },
      {
        title: "Confirm the specialty",
        text:
          "If your role branches into specialties, choose the one that fits your work.",
      },
      {
        title: "Save",
        text: "Your dashboard, jobs and salary cards update right away.",
      },
    ],
    tip: "Not sure? Choose the broader role — you can narrow it later.",
  },

  "saving-cities": {
    cat: "getting-started",
    title: "Saving & Syncing Cities",
    readTime: "1 min read",
    updated: "Jul 2026",
    desc:
      "Save cities to track their pay and cost of living. Your list syncs across every device.",
    dropLabel: "Drop a “Your cities” screenshot here",
    stepsTitle: "Manage saved cities",
    steps: [
      {
        title: "Add a city",
        text:
          "Tap the heart on a City Spotlight, or “Add city” under Your cities.",
      },
      {
        title: "Reorder or remove",
        text: "Use Manage in the “Your cities” panel to tidy your list.",
      },
      {
        title: "Sync everywhere",
        text: "Sign in on mobile and your saved cities appear automatically.",
      },
    ],
    tip:
      "Saved cities feed the Comparison tool — save every place you’re weighing.",
  },

  "salary-paycheck": {
    cat: "salaries",
    title: "Salary & Paycheck Calculators",
    readTime: "5 min read",
    updated: "Jul 2026",
    desc:
      "Salaries & Paychecks holds two calculators. Switch between them with the Hospital / Paycheck toggle at the top: one ranks real take-home across hospital contracts, the other breaks any salary down to what lands in your account each payday.",
    blocks: [
      {
        heading: "Hospital Salary Calculator",
        image: imgHospitalSalary,
        darkImage: imgHospitalSalaryDark,
        desc:
          "The Hospital Salary Calculator helps nurses compare earnings across hospitals based on union contracts, experience, work schedules, and shift differentials. It provides a transparent view of salary rankings to help healthcare professionals identify the highest-paying employers.",
        steps: [
          {
            title: "Hospital vs Paycheck View",
            text: "The calculator offers two ways to analyze compensation.",
            bullets: [
              {
                label: "Hospital",
                text:
                  "Compare salaries across hospitals and healthcare systems.",
              },
              {
                label: "Paycheck",
                text:
                  "Estimate your actual take-home earnings after taxes, deductions, and work schedule adjustments.",
              },
            ],
          },
          {
            title: "Profile Completion Progress",
            text:
              "The profile completion banner helps ensure salary calculations are tailored to your situation.",
            bullets: [
              "More accurate salary estimates",
              "Personalized hospital comparisons",
              "Better city and housing recommendations",
              "Improved financial planning insights",
            ],
          },
          {
            title: "Salary Summary",
            text:
              "At the top of the page, the calculator highlights the highest-paying hospital based on your selected criteria.",
            bullets: [
              "Top-ranked hospital",
              "Estimated monthly earnings",
              "Hospital ranking position",
              "Comparison against all hospitals in the database",
            ],
            note:
              "Purpose — quickly identify which employer offers the strongest earning potential.",
          },
          {
            title: "Salary Input Settings",
            text: "Customize calculations using your personal work details.",
            bullets: [
              {
                label: "Rate Period",
                text: "Display salary as Hourly, Weekly, Monthly or Annual.",
              },
              {
                label: "Hours Per Week",
                text:
                  "Enter your typical weekly working hours — changes update calculations and rankings instantly.",
              },
              {
                label: "Years of Experience",
                text:
                  "Select your experience level; most contracts increase pay with years of service.",
              },
              {
                label: "Position",
                text:
                  "Choose your role or shift type (Day, Evening, Night, or specialized positions), which may add pay differentials.",
              },
              {
                label: "Overtime Hours",
                text:
                  "Add expected overtime hours — overtime premiums are included automatically.",
              },
              {
                label: "Double Time Hours",
                text:
                  "Include double-time hours for a more accurate total across extended shifts and special schedules.",
              },
            ],
          },
          {
            title: "Hospital Salary Rankings",
            text:
              "The rankings table displays hospitals ordered by estimated earnings.",
            bullets: [
              "Hospital Name",
              "Location",
              "Monthly Salary Estimate",
              "Ranking Position",
              "Relative Salary Comparison",
            ],
            note:
              "How to use rankings — compare hospitals side-by-side to identify the best financial opportunities based on your qualifications and work preferences.",
          },
          {
            title: "Hospital Groups",
            text:
              "Some healthcare systems share common pay scales across multiple facilities.",
            bullets: [
              "Shared pay-scale indicators",
              "Related hospitals within the same system",
              "Grouped compensation structures",
            ],
            note:
              "Benefit — understand whether similar salary packages are available at multiple locations.",
          },
          {
            title: "State Filter",
            text:
              "Use the State Selector to narrow results to a specific region.",
            bullets: [
              "Compare hospitals within a single state",
              "Research relocation opportunities",
              "Analyze regional pay differences",
            ],
          },
          {
            title: "Top Hospital Summary Card",
            text:
              "The summary card highlights the highest-paying employer based on your selected inputs.",
            bullets: [
              "Hospital Name",
              "Highest Monthly Salary",
              "Estimated Net Pay",
              "Overall Ranking Position",
            ],
            note:
              "Why it matters — a quick snapshot of the most financially rewarding opportunity available within your selected criteria.",
          },
          {
            title: "Key Benefits",
            text: "The Hospital Salary Calculator enables nurses to:",
            bullets: [
              "Compare hospital salaries instantly",
              "Understand the impact of experience and shifts",
              "Evaluate overtime earnings",
              "Discover top-paying healthcare employers",
              "Make informed career and relocation decisions",
            ],
          },
        ],
        tip:
          "By combining union contract data with customizable inputs, the calculator helps healthcare professionals maximize their earning potential.",
      },
      {
        heading: "Paycheck Calculator",
        image: imgPaycheck,
        darkImage: imgPaycheckDark,
        desc:
          "The Paycheck Calculator helps nurses estimate exactly how much money they will receive after taxes and deductions. By entering salary information, work location, and benefit contributions, users can view detailed paycheck breakdowns and annual earnings projections.",
        steps: [
          {
            title: "Hospital vs Paycheck Mode",
            text: "The calculator provides two compensation analysis options.",
            bullets: [
              {
                label: "Hospital",
                text:
                  "Compare earnings across hospitals using union contract data.",
              },
              {
                label: "Paycheck",
                text:
                  "Calculate actual take-home pay after taxes, insurance, retirement contributions, and other deductions.",
              },
            ],
          },
          {
            title: "Estimated Take-Home Pay",
            text:
              "The top summary displays your projected paycheck amount based on the selected salary and tax settings.",
            bullets: [
              "Estimated Take-Home Amount",
              "Pay Frequency",
              "Take-Home Percentage",
              "Net Earnings After Deductions",
            ],
            note:
              "Why it matters — a quick understanding of how much money reaches your bank account each pay period.",
          },
          {
            title: "Saved Paychecks",
            text: "Save multiple paycheck calculations for future reference.",
            bullets: [
              "Save paycheck scenarios",
              "Compare different salary options",
              "Review previous calculations",
              "Track compensation changes over time",
            ],
            note:
              "Benefits — helpful when evaluating multiple job offers or relocation opportunities.",
          },
          {
            title: "Location & Role Information",
            text:
              "Customizes tax calculations based on your employment details.",
            bullets: [
              {
                label: "Nursing Role",
                text:
                  "Select your nursing specialty or position; different roles may have varying salary ranges and compensation structures.",
              },
              {
                label: "State & City",
                text:
                  "Choose your work location; federal, state and local taxes vary by location and directly impact take-home pay.",
              },
            ],
          },
          {
            title: "Salary Information",
            text: "Enter compensation details to calculate earnings.",
            bullets: [
              {
                label: "Pay Type",
                text:
                  "Choose Salary or Hourly Rate — supports both salaried and hourly healthcare professionals.",
              },
              {
                label: "Annual Gross Salary",
                text:
                  "Enter yearly earnings before taxes and deductions; the foundation for all paycheck calculations.",
              },
              {
                label: "Pay Frequency",
                text:
                  "Select Weekly, Bi-Weekly, Semi-Monthly or Monthly; estimates update to the selected pay schedule.",
              },
              {
                label: "Filing Status",
                text:
                  "Choose Single, Married Filing Jointly, Married Filing Separately or Head of Household; withholding varies by status.",
              },
            ],
          },
          {
            title: "Pre-Tax Deductions",
            text:
              "Optional benefit contributions can be included for more accurate paycheck estimates.",
            bullets: [
              {
                label: "401(k) Contributions",
                text:
                  "Add retirement savings; reduces taxable income while increasing retirement savings.",
              },
              {
                label: "HSA Contributions",
                text:
                  "Include Health Savings Account contributions for tax-advantaged healthcare savings.",
              },
              {
                label: "Health Insurance Premiums",
                text:
                  "Enter employee-paid insurance costs to reflect actual deductions.",
              },
              {
                label: "FSA Contributions",
                text:
                  "Add Flexible Spending Account contributions for pre-tax healthcare or dependent care expenses.",
              },
            ],
          },
          {
            title: "Per Paycheck Breakdown",
            text: "A detailed analysis of how earnings are distributed.",
            bullets: [
              "Gross Pay",
              "Federal Tax",
              "State Tax",
              "Local Tax",
              "Social Security",
              "Medicare",
              "State Insurance",
              "Pre-Tax Deductions",
              "Post-Tax Deductions",
              "Total Taxes",
              "Final Take-Home Pay",
            ],
            note:
              "Why it matters — helps you understand exactly where deductions occur.",
          },
          {
            title: "Income Distribution Chart",
            text:
              "A visual chart illustrating how each dollar of income is allocated.",
            bullets: [
              "Take-Home Pay",
              "Federal Taxes",
              "State Taxes",
              "Local Taxes",
              "FICA Taxes",
              "Insurance Contributions",
            ],
            note:
              "Benefits — makes complex tax information easier to understand at a glance.",
          },
          {
            title: "Annual Summary",
            text: "A yearly financial overview.",
            bullets: [
              "Gross Annual Income",
              "Net Annual Income",
              "Total Taxes Paid",
              "Effective Tax Rate",
            ],
            note:
              "Purpose — evaluate long-term earnings and financial planning opportunities.",
          },
          {
            title: "Save Paycheck",
            text: "Save your completed paycheck calculations.",
            bullets: [
              "Compare multiple compensation scenarios",
              "Track career growth",
              "Evaluate job offers",
              "Support financial planning decisions",
            ],
          },
          {
            title: "Key Benefits",
            text: "The Paycheck Calculator allows healthcare professionals to:",
            bullets: [
              "Estimate real take-home pay",
              "Understand tax obligations",
              "Compare compensation scenarios",
              "Analyze benefit deductions",
              "Make informed financial decisions",
            ],
          },
        ],
        tip:
          "By combining salary data, tax calculations, and benefit contributions, the calculator delivers a complete picture of actual earnings and financial impact.",
      },
    ],
    steps: [],
    tip: "",
  },

  "mortgage-how": {
    cat: "mortgage",
    title: "Mortgage Calculator",
    readTime: "4 min read",
    updated: "Jul 2026",
    image: imgMortgage,
    darkImage: imgMortgageDark,
    desc:
      "The Mortgage Calculator helps nurses understand how much home they can realistically afford based on their income, location, and housing market conditions. It estimates monthly mortgage payments and compares homeownership costs with local rental prices.",
    stepsTitle: "What’s on the Mortgage Calculator",
    steps: [
      {
        title: "Profile Completion",
        text:
          "The profile progress bar helps personalize affordability calculations.",
        bullets: [
          "More accurate home affordability estimates",
          "Personalized salary-based recommendations",
          "Better housing comparisons",
          "Improved financial planning insights",
        ],
      },
      {
        title: "Saved Scenarios",
        text:
          "Save mortgage calculations to compare different cities, home values, and financing options.",
        bullets: [
          "Save affordability scenarios",
          "Compare housing markets",
          "Revisit previous calculations",
          "Track changing mortgage conditions",
        ],
        note:
          "Why it matters — makes it easier to evaluate multiple locations before making a home-buying decision.",
      },
      {
        title: "Location & Nursing Profile",
        text:
          "Customize affordability calculations using your profession and preferred location.",
        bullets: [
          {
            label: "Nursing Role",
            text:
              "Select your specialty or position; income estimates are tailored to your nursing profession.",
          },
          {
            label: "State & City",
            text:
              "Choose where you plan to purchase; housing prices, taxes and affordability vary significantly by location.",
          },
        ],
      },
      {
        title: "Home Value",
        text:
          "The calculator automatically displays the typical home value for the selected region.",
        bullets: [
          "Reflects local housing market conditions",
          "Provides realistic affordability estimates",
          "Helps compare cities more effectively",
        ],
      },
      {
        title: "Down Payment",
        text:
          "Adjust the amount you plan to pay upfront when purchasing a home.",
        bullets: [
          "Higher down payments reduce monthly mortgage costs.",
          "Lower down payments increase monthly payments and financing requirements.",
        ],
        note:
          "Benefit — understand how different down payment amounts impact affordability.",
      },
      {
        title: "Loan Term",
        text: "Select the length of your mortgage loan.",
        bullets: [
          {
            label: "15-Year Mortgage",
            text:
              "Higher monthly payments, lower total interest paid, and faster home ownership.",
          },
          {
            label: "30-Year Mortgage",
            text:
              "Lower monthly payments and greater affordability, but higher lifetime interest costs.",
          },
        ],
      },
      {
        title: "Interest Rate",
        text: "Enter or adjust the mortgage interest rate.",
        note:
          "Interest rates directly affect monthly payments and total borrowing costs — explore how changing market rates impact affordability.",
      },
      {
        title: "Monthly Payment Estimate",
        text: "The calculator provides a complete monthly mortgage breakdown.",
        bullets: [
          "Principal & Interest",
          "Property Taxes",
          "Homeowners Insurance",
          "Total Monthly Payment",
        ],
        note:
          "Why it matters — shows the true cost of homeownership beyond the loan payment alone.",
      },
      {
        title: "Affordability Analysis",
        text:
          "The affordability indicator evaluates whether the mortgage payment fits within your financial situation.",
        bullets: [
          "Affordability Status",
          "Mortgage-to-Income Ratio",
          "Estimated Take-Home Pay Impact",
        ],
        note:
          "Purpose — helps determine whether a home purchase is financially sustainable.",
      },
      {
        title: "Down Payment Requirement",
        text:
          "Shows the estimated amount needed upfront to purchase the selected property.",
        bullets: ["Down Payment Percentage", "Required Cash Amount"],
        note:
          "Benefit — helps you prepare financially before entering the home-buying process.",
      },
      {
        title: "Save Scenario",
        text: "Save mortgage calculations for future comparison.",
        bullets: [
          "Compare different cities",
          "Evaluate multiple home values",
          "Review affordability changes over time",
          "Plan future home purchases",
        ],
      },
      {
        title: "Renting vs Owning Comparison",
        text: "Compare the cost of renting versus buying in the selected city.",
        bullets: [
          "Average Monthly Rent",
          "Estimated Mortgage Payment",
          "Monthly Cost Difference",
        ],
        note:
          "Why it matters — helps determine whether renting or homeownership is the more cost-effective option.",
      },
      {
        title: "Home Search Resources",
        text:
          "Quick access to popular real estate platforms for exploring available properties.",
        bullets: ["Zillow Listings", "Redfin Listings"],
        note:
          "Benefit — move directly from affordability planning to home searching.",
      },
      {
        title: "Key Benefits",
        text: "The Mortgage Calculator helps healthcare professionals:",
        bullets: [
          "Estimate affordable home prices",
          "Understand mortgage costs",
          "Compare renting versus owning",
          "Evaluate different loan options",
          "Plan down payments",
          "Make informed housing decisions",
        ],
      },
    ],
    tip:
      "By combining nursing income data with local housing market information, the calculator provides a realistic picture of home affordability and long-term financial impact.",
  },

  piti: {
    cat: "mortgage",
    title: "PITI Explained",
    readTime: "3 min read",
    updated: "Jun 2026",
    desc:
      "PITI stands for Principal, Interest, Taxes and Insurance — the four parts of a typical monthly mortgage payment. MapMyPay bundles them into one number so nothing surprises you.",
    dropLabel: "Drop a PITI breakdown screenshot here",
    stepsTitle: "The four parts of PITI",
    steps: [
      {
        title: "Principal & interest",
        text:
          "The core loan repayment, driven by home price, down payment, rate and term.",
      },
      {
        title: "Property taxes",
        text:
          "Estimated annual property tax for the city, spread across twelve months.",
      },
      {
        title: "Insurance",
        text:
          "Homeowner’s insurance (and PMI, if your down payment is under 20%) rounds out the figure.",
      },
    ],
    tip:
      "A larger down payment can remove PMI entirely, cutting your monthly PITI.",
  },

  affordability: {
    cat: "mortgage",
    title: "Down Payment & Affordability",
    readTime: "3 min read",
    updated: "Jul 2026",
    desc:
      "Your down payment reshapes everything downstream — loan size, monthly payment and whether PMI applies. This guide shows how MapMyPay models affordability against your pay.",
    dropLabel: "Drop an affordability snapshot here",
    stepsTitle: "Improving affordability",
    steps: [
      {
        title: "Increase the down payment",
        text:
          "A higher percentage shrinks the loan and can remove PMI, lowering PITI.",
      },
      {
        title: "Watch the rate",
        text:
          "Even a small rate change moves the monthly payment — test a range to see the swing.",
      },
      {
        title: "Compare to leftover",
        text:
          "The affordability percentage compares PITI to your take-home so you can judge headroom.",
      },
    ],
    tip:
      "The “% of pay” ring turns red as the payment eats into too large a share of your income.",
  },

  "compare-cities": {
    cat: "comparison",
    title: "Live Here, Work There",
    readTime: "4 min read",
    updated: "Jul 2026",
    image: imgLiveHereWorkThere,
    darkImage: imgLiveHereWorkThereDark,
    desc:
      "The Live Here, Work There tool helps nurses compare the financial impact of working in one city while living in another. It combines salary, taxes, and housing costs to show how much money remains after major monthly expenses.",
    stepsTitle: "What’s on Live Here, Work There",
    steps: [
      {
        title: "Purpose",
        text:
          "Many healthcare professionals choose to work in higher-paying cities while living in more affordable locations. This calculator helps determine whether that strategy improves overall financial outcomes.",
      },
      {
        title: "Work Location",
        text: "Select where your job is located.",
        bullets: ["Nursing Role", "Work State", "Work City"],
        note:
          "Why it matters — salary levels are based on the selected work location and nursing position.",
      },
      {
        title: "Living Location",
        text: "Select where you currently live or plan to live.",
        bullets: ["State", "City"],
        note:
          "Why it matters — housing costs and living expenses are calculated using your residential location.",
      },
      {
        title: "Comparison Summary",
        text:
          "The summary cards provide a quick overview of your financial situation based on the selected locations.",
        bullets: [
          {
            label: "Median Gross Salary",
            text:
              "Estimated monthly income for your role in the work location — regional pay data and role-specific insights show your earning potential before major expenses.",
          },
          {
            label: "Average Housing Cost",
            text:
              "Estimated monthly housing expenses in your living location, using average rental costs and local market estimates to identify more affordable options.",
          },
          {
            label: "Income Taxes",
            text:
              "Estimated federal, state and local taxes based on your earnings and location, for a realistic view of actual earnings after taxation.",
          },
          {
            label: "Remaining Income",
            text:
              "Salary − Taxes − Housing Costs — the most important metric for evaluating overall financial quality of life.",
          },
        ],
      },
      {
        title: "Income vs Expenses Analysis",
        text:
          "The visual comparison chart shows how income compares against total monthly expenses.",
        bullets: [
          { label: "Income", text: "Represents estimated monthly earnings." },
          {
            label: "Expenses",
            text:
              "Represents combined housing costs, taxes and other major expenses.",
          },
        ],
        note:
          "Benefits — quickly identify financial surpluses or deficits, compare multiple location combinations, and evaluate relocation opportunities.",
      },
      {
        title: "Financial Health Indicators",
        text:
          "The calculator highlights whether your selected living and working arrangement is financially sustainable.",
        bullets: [
          {
            label: "Positive Outcome",
            text:
              "When remaining income is positive, the combination may offer stronger savings potential.",
          },
          {
            label: "Negative Outcome",
            text:
              "When expenses exceed income, the tool alerts you that the combination may not be financially practical.",
          },
        ],
      },
      {
        title: "How to Use This Tool",
        text: "Work through the calculator in order:",
        bullets: [
          "Select your Nursing Role.",
          "Choose your Work State and Work City.",
          "Choose your Living State and Living City.",
          "Review salary, housing, and tax estimates.",
          "Analyze remaining income and expense comparisons.",
          "Test different city combinations to find the best financial outcome.",
        ],
      },
      {
        title: "Key Benefits",
        text: "The Live Here, Work There calculator helps nurses:",
        bullets: [
          "Compare cities side-by-side",
          "Understand commuting and relocation trade-offs",
          "Identify higher savings opportunities",
          "Evaluate housing affordability",
          "Make informed career and lifestyle decisions",
        ],
      },
    ],
    tip:
      "By combining salary data, taxes, and housing costs into a single comparison, the tool helps healthcare professionals discover where they can maximize both income and quality of life.",
  },

  "compare-metrics": {
    cat: "comparison",
    title: "Which Metrics to Compare",
    readTime: "2 min read",
    updated: "Jun 2026",
    desc:
      "Not every metric matters equally. This guide helps you decide which numbers deserve the most weight when a decision is close.",
    dropLabel: "Drop a metrics screenshot here",
    stepsTitle: "Prioritising metrics",
    steps: [
      {
        title: "Lead with leftover",
        text:
          "After-tax, after-housing pay is the truest measure of day-to-day comfort.",
      },
      {
        title: "Factor in growth",
        text:
          "Consider job availability for your role, not just today’s salary.",
      },
      {
        title: "Weigh lifestyle",
        text:
          "Climate, community size and grades matter when finances are close.",
      },
    ],
    tip:
      "When two cities are within a few hundred dollars, let job availability break the tie.",
  },

  "job-search": {
    cat: "jobs",
    title: "Jobs",
    readTime: "6 min read",
    updated: "Jul 2026",
    desc:
      "The Jobs area has two connected views — the Jobs listing page for browsing and filtering openings, and the Job Detail page for evaluating a single opportunity in depth. Both show estimated earnings, requirements and affordability so you can compare positions on equal footing.",
    blocks: [
      {
        heading: "Jobs Listing Page",
        image: imgJobsListing,
        darkImage: imgJobsListingDark,
        desc:
          "The Jobs section helps nurses discover employment opportunities while showing estimated earnings, role requirements, and work preferences. Advanced filtering tools make it easy to find positions that match specific career goals, specialties, and locations.",
        steps: [
          {
            title: "Purpose",
            text:
              "The Jobs platform centralizes nursing opportunities and provides compensation insights so healthcare professionals can compare positions and make informed career decisions.",
          },
          {
            title: "Search Jobs",
            text: "Use the search bar to quickly find opportunities.",
            bullets: [
              "Job Title",
              "Hospital Name",
              "Healthcare System",
              "Keywords",
            ],
            note:
              "Benefit — quickly locate relevant opportunities without manually browsing listings.",
          },
          {
            title: "Jobs & Applied Jobs Tabs",
            text:
              "The platform separates active opportunities from submitted applications.",
            bullets: [
              {
                label: "Jobs",
                text:
                  "Browse available positions that match your criteria — real-time listings, salary information, job requirements and application access.",
              },
              {
                label: "Applied Jobs",
                text:
                  "Track positions you have already applied for; monitor activity, review submissions and stay organized during your search.",
              },
            ],
          },
          {
            title: "Job Filters",
            text:
              "Powerful filtering options help narrow results to the most relevant opportunities.",
            bullets: [
              {
                label: "Nursing Role",
                text:
                  "Filter by profession — Registered Nurse (RN), Licensed Practical Nurse (LPN), Nurse Practitioner (NP), Certified Nursing Assistant (CNA).",
              },
              {
                label: "Specialty",
                text:
                  "Find jobs within a specialty such as ICU, NICU, Oncology, Pediatrics, Labor & Delivery or Emergency Care.",
              },
              {
                label: "Sub-Specialty",
                text:
                  "Refine further by specialized clinical expertise to discover highly targeted opportunities.",
              },
              {
                label: "Job Title",
                text:
                  "Search specific positions like Staff Nurse, Charge Nurse, Clinical Nurse or Nurse Manager.",
              },
              {
                label: "Employer",
                text:
                  "Filter by healthcare organization or hospital system to focus on preferred employers.",
              },
              {
                label: "Location & State",
                text:
                  "Find jobs by city, region or state to explore relocation, search locally and compare regional job markets.",
              },
            ],
          },
          {
            title: "Job Type Filters",
            text: "Select the type of employment that fits your lifestyle.",
            bullets: [
              "Full-Time",
              "Part-Time",
              "Contract",
              "Per-Diem",
              "Temporary",
              "Travel Nursing",
            ],
            note:
              "Benefit — match opportunities with your preferred work schedule.",
          },
          {
            title: "Shift Type Filters",
            text: "Search positions based on shift preferences.",
            bullets: [
              "Day Shift",
              "Evening Shift",
              "Night Shift",
              "Flexible",
              "Rotating",
            ],
            note:
              "Purpose — find jobs that align with your preferred work-life balance.",
          },
          {
            title: "Work Mode Filters",
            text: "Choose how you want to work.",
            bullets: ["On-Site", "Remote", "Hybrid"],
            note:
              "Benefit — quickly identify opportunities that fit your working preferences.",
          },
          {
            title: "Sorting Options",
            text: "Organize results according to your priorities.",
            bullets: ["Salary", "Posted Date"],
            note:
              "Why it matters — prioritize the highest-paying or most recently posted opportunities.",
          },
          {
            title: "Job Listing Cards",
            text:
              "Each job card provides a complete overview of the opportunity.",
            bullets: [
              "Hospital or Employer Name",
              "Job Title",
              "Location",
              "Pay Range",
              "Posting Date",
              "Number of Applicants",
              "Required License",
              "Required Certifications",
              "Education Requirements",
              "Experience Requirements",
              "Specialty Information",
            ],
            note:
              "Benefit — evaluate opportunities without opening individual job pages.",
          },
          {
            title: "Work Preference Tags",
            text: "Job cards include quick-reference employment indicators.",
            bullets: [
              "On-Site",
              "Day Shift",
              "Evening Shift",
              "Part-Time",
              "Temporary",
              "Per-Diem",
            ],
            note: "Purpose — quickly understand job expectations at a glance.",
          },
          {
            title: "Apply Now",
            text:
              "The Apply Now button allows users to submit applications directly.",
            bullets: [
              "Faster application process",
              "Direct access to opportunities",
              "Simplified job searching workflow",
            ],
          },
          {
            title: "Job Insights",
            text:
              "The platform provides compensation transparency and qualification requirements before applying.",
            bullets: [
              "Compare salaries",
              "Identify required certifications",
              "Understand employer expectations",
              "Find higher-paying opportunities",
            ],
          },
          {
            title: "Key Benefits",
            text: "The Jobs section enables healthcare professionals to:",
            bullets: [
              "Discover nursing opportunities faster",
              "Compare salaries and employers",
              "Filter jobs by specialty and location",
              "Track applications",
              "Identify roles matching qualifications",
              "Make informed career decisions",
            ],
          },
        ],
        tip:
          "By combining advanced search filters, compensation data, and detailed job requirements, the Jobs platform simplifies the process of finding the right nursing opportunity.",
      },
      {
        heading: "Job Detail Page",
        image: imgJobDetail,
        darkImage: imgJobDetailDark,
        desc:
          "The Job Detail page provides a complete overview of a nursing opportunity, including salary, job requirements, affordability insights, housing data, and related career opportunities. It helps healthcare professionals evaluate whether a position aligns with their financial and career goals before applying.",
        steps: [
          {
            title: "Purpose",
            text:
              "This page combines employment information with local cost-of-living data, allowing users to understand not only what a job pays, but also what that salary means in real-world financial terms.",
          },
          {
            title: "Job Overview",
            text:
              "The top section displays essential information about the position.",
            bullets: [
              "Employer Name",
              "Job Title",
              "Hospital Name",
              "Job Location",
              "Posted Date",
              "Hourly Pay Range",
              "Applicant Activity",
            ],
            note:
              "Purpose — a quick summary of the opportunity before reviewing detailed information.",
          },
          {
            title: "Job Description",
            text: "A detailed overview of the position and responsibilities.",
            bullets: [
              "Role Summary",
              "Department Information",
              "Patient Care Responsibilities",
              "Required Skills",
              "Shift Expectations",
              "Employer Overview",
            ],
            note:
              "Benefit — helps candidates understand daily responsibilities and workplace expectations.",
          },
          {
            title: "Job Requirements",
            text: "Review the qualifications required for the position.",
            bullets: [
              "Bonus Information",
              "Minimum Education Requirement",
              "Required License",
              "Required Certifications",
              "Minimum Years of Experience",
              "Specialty Requirements",
            ],
            note:
              "Why it matters — ensures applicants meet employer expectations before applying.",
          },
          {
            title: "Employment Details",
            text: "Quick tags highlight key job characteristics.",
            bullets: [
              "On-Site",
              "Remote",
              "Hybrid",
              "Day Shift",
              "Evening Shift",
              "Night Shift",
              "Full-Time",
              "Part-Time",
              "Contract",
            ],
            note: "Benefit — an instant overview of work conditions.",
          },
          {
            title: "Apply Now",
            text: "Submit an application directly from the job detail page.",
            bullets: [
              "Faster application process",
              "Direct access to employers",
              "Streamlined career search experience",
            ],
          },
          {
            title: "Quick Actions",
            text: "Additional tools help users manage opportunities.",
            bullets: ["View on Map", "Save Job", "Share Job"],
            note:
              "Benefits — bookmark opportunities, share openings with colleagues, and explore surrounding areas.",
          },
          {
            title: "Hospital Information",
            text:
              "Displays healthcare facilities associated with the position.",
            bullets: [
              "Hospital Name",
              "Address",
              "Nearby Healthcare Facilities",
            ],
            note:
              "Purpose — provides location context and employer information.",
          },
          {
            title: "Related Jobs in This City",
            text: "Discover additional opportunities within the same location.",
            bullets: [
              "Compare salaries",
              "Explore alternative positions",
              "Identify better opportunities nearby",
            ],
          },
          {
            title: "City Salary & Housing Analysis",
            text:
              "The platform compares the job’s compensation against local living costs.",
            bullets: [
              "Average Salary in the City",
              "Typical Home Value",
              "Remaining Income When Renting",
              "Remaining Income When Owning",
            ],
            note:
              "Purpose — shows how far a nursing salary stretches in the selected location.",
          },
          {
            title: "Monthly Spending Breakdown",
            text:
              "Visual charts help users understand where income is allocated.",
            bullets: [
              "Taxes",
              "Housing Costs",
              "Remaining Income",
              "Other Living Expenses",
            ],
            note: "Benefit — makes salary affordability easier to understand.",
          },
          {
            title: "Affordability Calculator",
            text: "One of the most valuable features on the page.",
            bullets: [
              "Estimated Net Pay",
              "Local Rent Costs",
              "Mortgage Costs",
              "Housing-to-Income Ratio",
              "Renting & Homeownership Affordability",
              "Financial Recommendations",
            ],
            note:
              "Why it matters — helps you determine whether you can comfortably live in the area on the advertised salary.",
          },
          {
            title: "Down Payment Estimate",
            text:
              "Provides an estimate of the cash needed to purchase a home in the area.",
            bullets: [
              "Down Payment Percentage",
              "Required Down Payment Amount",
            ],
            note: "Purpose — helps you prepare for potential homeownership.",
          },
          {
            title: "Housing Marketplace Links",
            text: "Direct access to local housing listings.",
            bullets: ["Zillow Property Listings", "Redfin Property Listings"],
            note:
              "Benefits — explore available homes, research local housing markets, and evaluate relocation opportunities.",
          },
          {
            title: "Similar Jobs",
            text:
              "Recommended positions based on role, specialty, and location.",
            bullets: [
              "Discover alternative opportunities",
              "Compare compensation packages",
              "Expand job search options",
            ],
          },
          {
            title: "Live Here, Work There Tool",
            text: "Quickly compare the current job location with another city.",
            bullets: [
              "Compare affordability",
              "Analyze housing costs",
              "Identify stronger savings opportunities",
            ],
            note:
              "Purpose — evaluate whether living in a different city while working in the selected location would improve financial outcomes.",
          },
          {
            title: "Data Transparency",
            text:
              "The page includes housing and salary data sources to improve accuracy and trust.",
            bullets: [
              "Housing Market Research",
              "Salary Databases",
              "Regional Cost-of-Living Data",
            ],
            note:
              "Benefit — provides confidence in the financial insights displayed throughout the platform.",
          },
          {
            title: "Key Benefits",
            text: "The Job Detail page helps healthcare professionals:",
            bullets: [
              "Understand compensation beyond salary",
              "Evaluate affordability before relocating",
              "Compare renting versus owning",
              "Research local housing markets",
              "Explore related opportunities",
              "Make informed career decisions",
            ],
          },
        ],
        tip:
          "By combining job details, housing affordability, salary analysis, and local market insights, the Job Detail page transforms a standard job listing into a complete career decision-making tool.",
      },
    ],
    steps: [],
    tip: "",
  },

  "job-alerts": {
    cat: "jobs",
    title: "Setting Up Job Alerts",
    readTime: "2 min read",
    updated: "Jun 2026",
    desc:
      "Let new roles come to you. Alerts notify you when openings matching your role and cities are posted.",
    dropLabel: "Drop a job alerts screenshot here",
    stepsTitle: "Creating an alert",
    steps: [
      {
        title: "Set your criteria",
        text: "Choose the role and cities you want to be notified about.",
      },
      {
        title: "Pick a frequency",
        text:
          "Instant, daily or weekly — match it to how actively you’re searching.",
      },
      {
        title: "Manage alerts",
        text:
          "Pause or delete alerts any time from your notification settings.",
      },
    ],
    tip:
      "A weekly digest keeps you informed without flooding your inbox during a passive search.",
  },

  "city-filters": {
    cat: "cities",
    title: "Search Cities",
    readTime: "7 min read",
    updated: "Jul 2026",
    desc:
      "Search Cities has two connected views — the Search Cities page for exploring and comparing thousands of cities, and the City Detail page for an in-depth analysis of a single location. Together they cover salary potential, housing affordability, licensing, demographics and lifestyle.",
    blocks: [
      {
        heading: "Search Cities Page",
        image: imgSearchCities,
        darkImage: imgSearchCitiesDark,
        desc:
          "The Search Cities page helps nurses explore and compare thousands of cities based on salary potential, housing costs, taxes, affordability, and overall financial outcomes. It enables users to discover where they can maximize take-home income and improve their quality of life.",
        steps: [
          {
            title: "Purpose",
            text:
              "Finding the right city can significantly impact earnings, living expenses, and long-term financial goals. This tool provides location-based insights to help nurses make informed relocation and career decisions.",
          },
          {
            title: "Search Bar",
            text: "Quickly find cities using keywords and filters.",
            bullets: [
              "City Name",
              "Nursing Role",
              "Salary Range",
              "Location Preferences",
            ],
            note:
              "Benefit — instantly access city-specific salary and affordability information.",
          },
          {
            title: "Quick Filters",
            text: "Refine city results using advanced filtering options.",
            bullets: [
              {
                label: "Nursing Role",
                text:
                  "Select your profession — Registered Nurse (RN), Licensed Practical Nurse (LPN), Nurse Practitioner (NP) or Travel Nurse; salary projections vary by specialty and experience.",
              },
              {
                label: "Crime Rating",
                text:
                  "Filter by safety and crime levels to find communities that align with personal and family preferences.",
              },
              {
                label: "Compact State Filter",
                text:
                  "Limit results by nursing compact license eligibility for greater employment flexibility.",
              },
              {
                label: "Home Price Filter",
                text:
                  "Filter by housing affordability — Any, Affordable, Mid-Range or Premium markets — to match your homeownership goals.",
              },
              {
                label: "Additional Filters",
                text:
                  "Apply advanced criteria such as population size, tax levels, housing costs, affordability metrics and climate preferences.",
              },
            ],
          },
          {
            title: "Sorting Options",
            text: "Organize results according to financial priorities.",
            bullets: [
              "Highest Left After Rent",
              "Highest Salary",
              "Lowest Cost of Living",
              "Most Affordable Housing",
            ],
            note: "Why it matters — quickly identify top-performing locations.",
          },
          {
            title: "City Cards",
            text:
              "Each city card provides a financial snapshot for easy comparison.",
            bullets: [
              {
                label: "City Overview",
                text:
                  "City name, state, crime indicator and tax rate for a quick view of the area’s financial and lifestyle profile.",
              },
              {
                label: "Average Salary",
                text:
                  "Annual salary, monthly income and estimated net earnings for the selected nursing role.",
              },
              {
                label: "Housing Costs",
                text:
                  "Median home price, estimated mortgage cost and estimated rental cost — often the largest living expense.",
              },
              {
                label: "What You Keep After Housing",
                text:
                  "Estimated monthly income remaining after rent, and after mortgage, so you can compare renting versus owning.",
              },
              {
                label: "Rent vs Own Indicators",
                text:
                  "Rent and Own percentages showing whether renting or buying is more practical in each city.",
              },
              {
                label: "Down Payment Estimate",
                text:
                  "The estimated down payment required for homeownership, so upfront costs are clear before relocating.",
              },
              {
                label: "Community & Lifestyle Insights",
                text:
                  "Healthcare facility availability, climate, population size and local community data for context beyond salary and housing numbers.",
              },
            ],
          },
          {
            title: "Compare Cities",
            text:
              "The Compare button allows side-by-side analysis of multiple cities.",
            bullets: [
              "Compare salaries",
              "Compare housing costs",
              "Compare affordability",
              "Compare take-home income",
            ],
            note:
              "Why it matters — makes relocation decisions easier and more data-driven.",
          },
          {
            title: "View Details",
            text: "Open a dedicated city profile for deeper analysis.",
            bullets: [
              "Salary Breakdown",
              "Tax Analysis",
              "Housing Affordability",
              "Hospital Opportunities",
              "Local Market Insights",
            ],
          },
          {
            title: "Save Favorites",
            text: "Save preferred cities for future review.",
            bullets: [
              "Build a shortlist of target locations",
              "Compare cities later",
              "Track relocation opportunities",
            ],
          },
          {
            title: "Key Benefits",
            text: "The Search Cities tool helps healthcare professionals:",
            bullets: [
              "Discover high-paying locations",
              "Compare rent and homeownership affordability",
              "Analyze taxes and living expenses",
              "Evaluate relocation opportunities",
              "Identify cities with stronger financial outcomes",
              "Make confident career and lifestyle decisions",
            ],
          },
        ],
        tip:
          "By combining salary data, housing costs, taxes, and affordability metrics, Search Cities provides a complete picture of where nurses can earn more, save more, and live better.",
      },
      {
        heading: "City Detail Page",
        image: imgCityDetail,
        darkImage: imgCityDetailDark,
        desc:
          "The City Detail page provides an in-depth analysis of a city’s financial opportunities, housing affordability, licensing requirements, demographics, education, climate, and healthcare landscape. It helps nurses determine whether a city is a good fit for career growth, lifestyle preferences, and long-term financial goals.",
        steps: [
          {
            title: "Purpose",
            text:
              "This page combines salary data, housing costs, licensing information, and local community insights into a single resource, making it easier to evaluate relocation opportunities.",
          },
          {
            title: "City Overview",
            text:
              "The header section provides a quick summary of the selected city.",
            bullets: [
              "City Name",
              "State",
              "Nursing Role Context",
              "Crime Rating",
              "Nearby Hospitals",
            ],
            note:
              "Purpose — an immediate snapshot of the city’s overall profile.",
          },
          {
            title: "Salary & Housing Overview",
            text:
              "Understand how nursing salaries compare against local housing costs.",
            bullets: [
              "Average Nursing Salary",
              "Typical Home Value",
              "Remaining Income When Renting",
              "Remaining Income When Owning",
            ],
            note:
              "Why it matters — shows how much income remains after major housing expenses.",
          },
          {
            title: "Monthly Financial Breakdown",
            text:
              "The financial chart illustrates how income is distributed each month.",
            bullets: ["Income Taxes", "Mortgage Costs", "Remaining Income"],
            note:
              "Benefit — a visual understanding of affordability and spending patterns.",
          },
          {
            title: "Quick Actions",
            text: "Useful shortcuts for exploring and saving city information.",
            bullets: [
              "View on Map",
              "Compare with Another City",
              "Save to Your Cities",
              "Share City Profile",
            ],
            note: "Benefit — makes city research faster and more organized.",
          },
          {
            title: "Healthcare Availability",
            text:
              "Displays healthcare opportunities and facilities in the selected city.",
            bullets: [
              "Nearby Hospitals",
              "Healthcare Systems",
              "Available Nursing Jobs",
            ],
            note: "Purpose — helps evaluate local employment opportunities.",
          },
          {
            title: "Live Here, Work There",
            text: "Compare the selected city with another location.",
            bullets: [
              "Compare salary potential",
              "Compare living expenses",
              "Evaluate relocation strategies",
              "Identify stronger financial outcomes",
            ],
          },
          {
            title: "Home Affordability Calculator",
            text:
              "Calculate whether homeownership is realistic based on local housing prices and nursing income.",
            bullets: [
              {
                label: "Home Value",
                text:
                  "Average home value within the region for realistic local housing market expectations.",
              },
              {
                label: "Interest Rate",
                text:
                  "Adjust mortgage interest rates to explore financing scenarios and see how rates affect monthly payments.",
              },
              {
                label: "Down Payment",
                text:
                  "Adjust upfront contributions; shows the down payment percentage and required cash amount to plan homeownership costs.",
              },
              {
                label: "Loan Term",
                text:
                  "Compare 15-Year and 30-Year mortgages to weigh payment affordability against long-term interest costs.",
              },
              {
                label: "Housing Cost Summary",
                text:
                  "Estimated monthly ownership expenses including mortgage payment, living expenses and remaining income.",
              },
              {
                label: "Rent vs Own Comparison",
                text:
                  "Average rent, estimated mortgage and monthly cost difference to find the most financially practical housing option.",
              },
            ],
          },
          {
            title: "Real Estate Resources",
            text: "Direct links to property marketplaces.",
            bullets: ["Redfin Listings", "Zillow Listings"],
            note:
              "Benefit — research available homes directly from the platform.",
          },
          {
            title: "Nursing License Requirements",
            text:
              "Review licensing requirements applicable to the selected state.",
            bullets: [
              "License Eligibility",
              "Renewal Information",
              "State Regulations",
              "Application Requirements",
            ],
            note:
              "Purpose — helps nurses understand employment requirements before relocating.",
          },
          {
            title: "Continuing Education Units (CEUs)",
            text: "Information about continuing education requirements.",
            bullets: [
              "Required CEU Hours",
              "Renewal Cycles",
              "Education Guidelines",
            ],
            note:
              "Benefit — supports professional compliance and career development.",
          },
          {
            title: "Special Requirements",
            text: "State-specific nursing requirements and regulations.",
            bullets: [
              "Additional Certifications",
              "Background Checks",
              "Specialty Credentials",
              "State Compliance Rules",
            ],
          },
          {
            title: "Compact State Information",
            text:
              "Determine whether the state participates in the Nurse Licensure Compact (NLC).",
            bullets: [
              "Multi-state practice eligibility",
              "Greater employment flexibility",
              "Easier relocation opportunities",
            ],
          },
          {
            title: "Important Considerations for Compact State Nurses",
            text: "Guidance for nurses working across state lines.",
            bullets: [
              "Compact License Rules",
              "Practice Restrictions",
              "State Participation Requirements",
              "Compliance Considerations",
            ],
          },
          {
            title: "City Demographics",
            text: "Explore population and community characteristics.",
            bullets: [
              {
                label: "Education Levels",
                text:
                  "Educational attainment across the population — high school graduates, associate, bachelor’s and master’s degrees.",
              },
              {
                label: "Racial & Ethnic Diversity",
                text:
                  "Population diversity statistics to help understand the community makeup.",
              },
              {
                label: "Income Distribution",
                text:
                  "Household income levels from low to high income for economic context.",
              },
              {
                label: "Age Distribution",
                text:
                  "Population breakdown by age groups to understand demographics and service demand.",
              },
            ],
          },
          {
            title: "Community Statistics",
            text: "Additional city-level insights.",
            bullets: [
              "Crime Grade",
              "Crime Score",
              "Median Household Income",
              "Total Population",
              "Geographic Information",
            ],
            note: "Purpose — a broader picture of local quality of life.",
          },
          {
            title: "Nearby Schools",
            text:
              "Information about schools and educational institutions near the city.",
            bullets: [
              "Supports family relocation planning",
              "Provides educational context",
              "Helps evaluate local communities",
            ],
          },
          {
            title: "Annual Temperature & Climate",
            text: "Review weather patterns throughout the year.",
            bullets: [
              "Average Monthly High Temperatures",
              "Average Monthly Low Temperatures",
              "Seasonal Trends",
            ],
            note:
              "Benefit — helps determine whether the climate matches personal preferences.",
          },
          {
            title: "Data Sources & Transparency",
            text:
              "The platform includes data source references for housing, demographics, and market insights.",
            bullets: [
              "Housing Market Data",
              "Census Information",
              "Climate Statistics",
              "Healthcare Data",
            ],
            note:
              "Purpose — improves confidence in the information used throughout the city analysis.",
          },
          {
            title: "Key Benefits",
            text: "The City Detail page helps healthcare professionals:",
            bullets: [
              "Evaluate relocation opportunities",
              "Compare affordability across cities",
              "Understand licensing requirements",
              "Explore demographics and community data",
              "Assess housing affordability",
              "Review climate and lifestyle factors",
              "Make informed career and financial decisions",
            ],
          },
        ],
        tip:
          "By combining salary insights, housing analysis, licensing information, demographics, and local market data, the City Detail page provides a complete picture of what it’s like to live and work in a specific location.",
      },
    ],
    steps: [],
    tip: "",
  },

  "city-grades": {
    cat: "cities",
    title: "Understanding City Grades",
    readTime: "2 min read",
    updated: "Jun 2026",
    desc:
      "Each city carries a grade summarising how well it balances pay, cost of living and opportunity for your role — a quick way to sort a long list.",
    dropLabel: "Drop a city grade screenshot here",
    stepsTitle: "How grades are calculated",
    steps: [
      {
        title: "Weighted inputs",
        text:
          "Grades blend after-housing pay, job availability and cost of living.",
      },
      {
        title: "Role-specific",
        text:
          "Because inputs depend on your role, the same city can grade differently for different specialties.",
      },
      {
        title: "Use as a shortlist",
        text:
          "Treat grades as a starting filter, then compare finalists in detail.",
      },
    ],
    tip:
      "A city with no grade simply lacks enough data for your role yet — it isn’t a low score.",
  },

  "join-forum": {
    cat: "community",
    title: "Community",
    readTime: "6 min read",
    updated: "Jul 2026",
    desc:
      "Community has two connected views — the Community feed for reading, discussing and following, and the Create Post experience for contributing your own discussions and polls.",
    blocks: [
      {
        heading: "Community",
        image: imgCommunity,
        darkImage: imgCommunityDark,
        desc:
          "The Community section is a professional networking and discussion space designed specifically for nurses and healthcare professionals. It enables users to connect with peers, share experiences, ask questions, participate in industry discussions, and gain insights from the nursing community.",
        steps: [
          {
            title: "Community Feed",
            text:
              "The main feed displays posts, discussions, polls, and updates shared by healthcare professionals across different specialties and locations.",
            bullets: [
              {
                label: "",
                text: "Browse personalized and trending community content.",
              },
              {
                label: "",
                text:
                  "View posts from nurses, healthcare workers, and industry experts.",
              },
              {
                label: "Dedicated tabs",
                text:
                  "For You (personalized recommendations), Following (posts from followed members), All (the complete community feed) and Saved (bookmarked discussions and resources).",
              },
              {
                label: "Filter content",
                text: "By profession, specialty and location.",
              },
            ],
          },
          {
            title: "Create & Share Posts",
            text:
              "Users can contribute to the community by creating posts and sharing experiences.",
            bullets: [
              "Publish text-based discussions.",
              "Upload photos and supporting media.",
              "Share workplace experiences and career advice.",
              "Ask questions and receive feedback from peers.",
              "Create community polls to gather opinions.",
            ],
          },
          {
            title: "Polls",
            text:
              "Polls allow users to collect feedback and compare opinions from other healthcare professionals.",
            bullets: [
              "Gather community insights quickly.",
              "Compare experiences across hospitals and specialties.",
              "Participate in active healthcare discussions.",
              "View voting results and engagement statistics.",
            ],
          },
          {
            title: "Community Engagement",
            text: "Interact with content shared by other members.",
            bullets: [
              "Like posts.",
              "Comment on discussions.",
              "Share posts with other users.",
              "Repost useful content.",
              "Save posts for future reference.",
              "Follow community members.",
            ],
          },
          {
            title: "Trending Topics",
            text:
              "Quickly discover the most active conversations within the healthcare community.",
            bullets: [
              "Hospital Reviews",
              "Career Discussions",
              "Debt & Finance",
              "Specialty Nursing Discussions",
              "Workplace Experiences",
              "Relocation & Travel Nursing",
            ],
          },
          {
            title: "Community Highlights",
            text:
              "The Community Highlights panel showcases important conversations and active members.",
            bullets: [
              "Hot Topics",
              "Featured Discussions",
              "Popular Contributors",
              "Recommended Content",
              "Recent Community Activity",
            ],
          },
          {
            title: "Professional Networking",
            text:
              "Build meaningful connections with healthcare professionals across different locations and specialties.",
            bullets: [
              "Follow other nurses and healthcare workers.",
              "Discover professionals with similar interests.",
              "Expand industry connections.",
              "Learn from experienced practitioners.",
              "Engage in peer-to-peer knowledge sharing.",
            ],
          },
          {
            title: "Benefits of Using Community",
            text: "Why nurses use the Community:",
            bullets: [
              "Learn from real-world nursing experiences.",
              "Get career guidance from industry professionals.",
              "Stay informed about healthcare trends and workplace updates.",
              "Share knowledge and best practices.",
              "Build a strong professional healthcare network.",
              "Participate in discussions that support career growth and decision-making.",
            ],
          },
        ],
        tip:
          "Use the For You and Following tabs to keep your feed focused on the specialties and members most relevant to you.",
      },
      {
        heading: "Create Community Post",
        image: imgCreatePost,
        darkImage: imgCreatePostDark,
        desc:
          "The Create Post feature allows users to share experiences, ask questions, publish updates, start discussions, and engage with the nursing community.",
        steps: [
          {
            title: "Post Categories",
            text:
              "Categorize your content so it reaches the most relevant audience.",
            bullets: [
              "Hospital Review",
              "Debt & Finance",
              "Career Discussion",
              "News",
              "Salary Discussion",
              "Job Listings",
              "Announcements",
            ],
          },
          {
            title: "Post Information",
            text: "Give your post a clear title and detailed body.",
            bullets: [
              {
                label: "Post Title",
                text:
                  "A clear, descriptive title summarizing the topic — e.g. “My Experience Working at Stanford Hospital”, “Best ICU Certifications for Career Growth” or “Relocating from New York to California as an RN”.",
              },
              {
                label: "Post Content",
                text:
                  "Use the rich text editor with bold, italic, underline, hyperlinks, ordered and unordered lists, text formatting tools and image upload support.",
              },
            ],
          },
          {
            title: "Add Media",
            text:
              "Enhance your posts by attaching images and supporting visuals.",
            bullets: [
              "Share workplace examples.",
              "Showcase hospital facilities.",
              "Provide visual context for discussions.",
              "Increase community engagement.",
            ],
          },
          {
            title: "Create Polls",
            text:
              "The optional poll feature lets you gather opinions and feedback from other healthcare professionals.",
            bullets: [
              "Add multiple answer choices.",
              "Collect anonymous votes.",
              "View real-time results.",
              "Compare opinions across specialties and locations.",
            ],
            note:
              "Example polls — “Which nursing specialty offers the best work-life balance?”, “Are travel nursing contracts worth it in 2026?”, “Which EMR system do you prefer?”",
          },
          {
            title: "Community Engagement",
            text: "After publishing, community members can:",
            bullets: [
              "Like the post.",
              "Comment and participate in discussions.",
              "Share content with other users.",
              "Save posts for future reference.",
              "Vote on polls.",
              "Follow the author.",
            ],
          },
          {
            title: "Benefits of Posting",
            text: "Why post to the Community:",
            bullets: [
              "Share professional experiences and knowledge.",
              "Seek advice from healthcare professionals.",
              "Build credibility within the nursing community.",
              "Encourage peer-to-peer learning.",
              "Start meaningful discussions around healthcare topics.",
              "Stay connected with nurses across different regions and specialties.",
            ],
          },
        ],
        tip:
          "Choose an accurate category and a specific title — well-tagged posts reach the right nurses and get better answers.",
      },
    ],
    steps: [],
    tip: "",
  },

  posting: {
    cat: "community",
    title: "Posting & Etiquette",
    readTime: "2 min read",
    updated: "Jun 2026",
    desc:
      "Good posts get good answers. A few simple habits keep the community helpful and welcoming for everyone.",
    dropLabel: "Drop a post composer screenshot here",
    stepsTitle: "Posting well",
    steps: [
      {
        title: "Be specific",
        text:
          "Include your role, city and the exact question so people can help fast.",
      },
      {
        title: "Keep it kind",
        text: "Assume good faith and avoid sharing others’ private details.",
      },
      {
        title: "Mark what helped",
        text:
          "React to replies that solved your problem so future readers find them.",
      },
    ],
    tip:
      "Salary talk is welcome here — sharing ranges helps everyone benchmark fairly.",
  },

  "direct-messages": {
    cat: "messages",
    title: "Messages",
    readTime: "3 min read",
    updated: "Jul 2026",
    image: imgMessages,
    darkImage: imgMessagesDark,
    desc:
      "The Messages section enables direct communication between users, recruiters, employers, hospitals, and platform administrators. It provides a centralized inbox for managing conversations, sharing information, and collaborating efficiently.",
    stepsTitle: "What’s in Messages",
    steps: [
      {
        title: "Conversation List",
        text: "The left panel displays all active and previous conversations.",
        bullets: [
          { label: "", text: "View recent chats and message previews." },
          {
            label: "",
            text: "Search conversations using keywords or participant names.",
          },
          {
            label: "Access conversations with",
            text:
              "Recruiters, Employers, Hospitals, Platform Administrators and other Community Members.",
          },
          { label: "", text: "View message timestamps and latest activity." },
        ],
      },
      {
        title: "Chat Window",
        text:
          "The main chat area displays the selected conversation and message history.",
        bullets: [
          "Send and receive real-time messages.",
          "Review previous conversation history.",
          "View message delivery status.",
          "Organize conversations chronologically.",
          "Maintain ongoing communication with contacts.",
        ],
      },
      {
        title: "Media Sharing",
        text:
          "Exchange supporting files and visual content within conversations.",
        bullets: [
          "Images and screenshots",
          "Documents and attachments",
          "Job-related information",
          "Hospital resources",
          "Career-related materials",
        ],
      },
      {
        title: "Message Composer",
        text:
          "The message input area lets you create and send messages quickly.",
        bullets: [
          "Text messaging",
          "Image attachments",
          "Emoji support",
          "Instant message delivery",
          "Quick response communication",
        ],
      },
      {
        title: "Communication Use Cases",
        text: "Common ways nurses use Messages:",
        bullets: [
          {
            label: "Job Applications",
            text:
              "Communicate directly with recruiters, discuss application status, schedule interviews and request additional job information.",
          },
          {
            label: "Hospital & Employer Communication",
            text:
              "Clarify job requirements, discuss onboarding processes, ask employment-related questions and receive hiring updates.",
          },
          {
            label: "Community Networking",
            text:
              "Connect with healthcare professionals, share experiences and advice, build professional relationships and collaborate with peers across specialties.",
          },
        ],
      },
      {
        title: "Benefits",
        text: "Why nurses use Messages:",
        bullets: [
          "Centralized communication platform.",
          "Faster recruiter and employer interactions.",
          "Improved networking opportunities.",
          "Secure and organized conversation history.",
          "Enhanced collaboration within the nursing community.",
          "Easy sharing of professional information and resources.",
        ],
      },
    ],
    tip:
      "Use search to jump straight to a recruiter or hospital thread instead of scrolling your whole inbox.",
  },

  "reading-blogs": {
    cat: "blogs",
    title: "Blog",
    readTime: "3 min read",
    updated: "Jul 2026",
    image: imgBlog,
    darkImage: imgBlogDark,
    desc:
      "This section provides educational articles, salary insights, relocation guides, housing affordability analysis, tax-saving strategies, and career advice specifically for nurses. Users can explore data-driven content to make informed career and financial decisions.",
    stepsTitle: "What’s in the Blog",
    steps: [
      {
        title: "Key Features",
        text: "Explore data-driven articles and tools:",
        bullets: [
          "Browse latest nursing industry articles and research.",
          "Discover highest-paying cities and states for nurses.",
          "Compare salary vs cost of living across locations.",
          "Learn about tax impacts, housing affordability, and take-home pay.",
          "Access relocation and career growth guides.",
          "Filter articles by categories such as Career, Salary, Housing, Finance, and Statistics.",
          "View article summaries, publication dates, and featured insights.",
          "Open full articles for detailed analysis and recommendations.",
          "Stay updated with nursing market trends and employment opportunities.",
        ],
      },
      {
        title: "User Benefits",
        text: "Why nurses read the Blog:",
        bullets: [
          "Make smarter relocation decisions.",
          "Understand real earnings after taxes and housing costs.",
          "Explore salary trends by specialty and location.",
          "Gain financial planning insights tailored for healthcare professionals.",
          "Stay informed about nursing career opportunities nationwide.",
        ],
      },
    ],
    tip:
      "Filter by category to jump straight to the salary, housing or finance guides most relevant to your next move.",
  },

  "profile-page": {
    cat: "profile",
    title: "Profile",
    readTime: "4 min read",
    updated: "Jul 2026",
    image: imgProfile,
    darkImage: imgProfileDark,
    desc:
      "The Profile page is the user’s personal account hub where nurses can manage professional information, career preferences, saved resources, and account settings. It helps personalize recommendations across jobs, cities, salary insights, and relocation opportunities.",
    stepsTitle: "What’s on the Profile page",
    steps: [
      {
        title: "Profile Overview",
        text:
          "Displays your basic account information — profile picture, name, email address, follower count and following count. Update your personal details any time using the Edit Profile option.",
      },
      {
        title: "Professional Information",
        text: "Stores nursing-related details used throughout the platform:",
        bullets: [
          "Current nursing role and specialty",
          "License type and license number",
          "Nursing education level",
          "Years of experience",
          "Licensed states",
          "Compact nursing license status",
          "Employment preferences",
          "Relocation interests",
          "Salary expectations",
          "Preferred certifications",
          "Shift preferences",
          "Clinical experience and patient population",
        ],
        note:
          "This information helps generate more accurate salary estimates, job recommendations and relocation insights.",
      },
      {
        title: "Notification Preferences",
        text: "Control your communication settings:",
        bullets: [
          "Community notifications",
          "Job alerts",
          "Feature updates",
          "Newsletter subscriptions",
          "Promotional notifications",
        ],
      },
      {
        title: "Saved Paychecks",
        text:
          "Save and revisit paycheck calculations. Each saved paycheck includes salary details, take-home pay estimates and calculation history for future reference.",
      },
      {
        title: "Saved Cities",
        text:
          "Bookmark cities you’re interested in for relocation or career planning. Each saved city displays:",
        bullets: [
          "Nursing role",
          "Estimated net salary",
          "Typical home value",
          "Housing affordability insights",
        ],
      },
      {
        title: "Document Management",
        text: "Upload and manage important career documents:",
        bullets: [
          "Resume",
          "Nursing certifications",
          "Employment documents",
          "Pay stub records",
        ],
        note:
          "These documents can be used when applying for jobs and maintaining professional records.",
      },
      {
        title: "Social Profile Connections",
        text:
          "Connect your professional social profiles to build credibility and network within the nursing community.",
      },
      {
        title: "Subscription",
        text:
          "View and manage your current subscription plan, billing details and the premium features available through the platform.",
      },
      {
        title: "Referral",
        text:
          "Invite colleagues and earn referral rewards when new members join the platform.",
      },
      {
        title: "Account Settings",
        text:
          "Access essential account management features — including Contact us and Change password:",
        bullets: [
          "Change Password",
          "Contact Support",
          "Delete Account",
          "Manage Personal Preferences",
        ],
      },
    ],
    tip:
      "The Profile page keeps your credentials, preferences, saved calculations and account settings in one place — powering a personalized experience across the entire platform.",
  },

  subscription: {
    cat: "profile",
    title: "Subscription Membership",
    readTime: "5 min read",
    updated: "Jul 2026",
    desc:
      "The Subscription Membership page offers two billing options — Annual Billing for the best yearly value, and Monthly Billing for maximum flexibility. Both unlock the same premium salary, affordability and financial-planning tools.",
    blocks: [
      {
        heading: "Annual Billing",
        image: imgAnnualBilling,
        darkImage: imgAnnualBillingDark,
        desc:
          "The Annual Billing page allows users to subscribe to MapMyPay Pro at a discounted yearly rate. It provides access to advanced salary comparison tools, financial insights, and location-based analytics to help nurses maximize their take-home income while saving on subscription costs.",
        steps: [
          {
            title: "Purpose",
            text:
              "The Subscription Membership page lets you compare available membership plans and choose the annual option that best fits your career and financial goals. Annual billing offers premium features at a reduced yearly cost compared to monthly payments.",
          },
          {
            title: "Billing Options",
            text:
              "Choose how you would like to be billed for your subscription.",
            bullets: ["Monthly Billing", "Annual Billing (Save 17%)"],
            note:
              "Benefits — lower yearly cost, savings versus monthly billing, continuous access to premium features, and no monthly renewal management.",
          },
          {
            title: "Membership Plans",
            text:
              "Three plans scale from exploring the platform to full financial planning.",
            bullets: [
              {
                label: "Free",
                text:
                  "Limited access to RN salaries and cost-of-living data, up to 10 salary results, compare one city and one role at a time, community access and a prefilled city-specific retirement calculator. Best for new users exploring before upgrading.",
              },
              {
                label: "Pro — $29.99/year (Save 17%)",
                text:
                  "Cost-of-living filters, investment planning tools, nursing job market data, leftover income projections and salary comparison; compare unlimited cities and calculate real take-home pay. Best for nurses regularly comparing salaries, taxes and housing across cities.",
              },
              {
                label: "Pro + Newsletter — $49.99/year (Save 17%)",
                text:
                  "Everything in Pro plus the weekly MapMyPay Insider newsletter and curated weekly nursing job listings by email. A Current Plan badge marks your active subscription.",
              },
            ],
          },
          {
            title: "Platform Highlights",
            text: "The page showcases the scale and reliability of MapMyPay.",
            bullets: [
              {
                label: "9,000+ Nurses",
                text:
                  "A growing community of healthcare professionals using MapMyPay.",
              },
              {
                label: "21,000+ U.S. Cities",
                text:
                  "Comprehensive salary and affordability data covering thousands of cities nationwide.",
              },
              {
                label: "Updated Weekly",
                text:
                  "Salary, housing and financial data are refreshed regularly to provide accurate insights.",
              },
            ],
            note:
              "Why it matters — decisions are made using current, reliable and comprehensive location-based financial information.",
          },
          {
            title: "Frequently Asked Questions (FAQ)",
            text: "Common questions about subscriptions and billing:",
            bullets: [
              "Can I cancel my subscription anytime?",
              "What happens after my free trial?",
              "What is the difference between Pro and Pro + Newsletter?",
              "Will my existing subscription remain unchanged?",
              "How is take-home pay calculated?",
            ],
            note:
              "Benefit — quick answers help you confidently choose the right plan without contacting support.",
          },
          {
            title: "Why Choose Annual Billing?",
            text:
              "Annual billing is ideal if you plan to use MapMyPay throughout the year and want the best value.",
            bullets: [
              "Save 17% compared to monthly billing",
              "Lower overall subscription cost",
              "Full access to premium salary comparison tools",
              "Unlimited city searches and financial insights",
              "Continuous access without monthly renewals",
              "Exclusive premium features for long-term planning",
            ],
          },
        ],
        tip:
          "Choose Annual Billing to save 17% and unlock unlimited city comparisons and take-home analysis all year.",
      },
      {
        heading: "Monthly Billing",
        image: imgMonthlyBilling,
        darkImage: imgMonthlyBillingDark,
        desc:
          "The Monthly Billing page allows users to subscribe to MapMyPay Pro with a flexible monthly payment option. It provides full access to premium salary comparison tools, affordability insights, and financial planning resources without requiring a long-term commitment.",
        steps: [
          {
            title: "Purpose",
            text:
              "The Subscription Membership page lets you compare available membership plans and choose the monthly option that best fits your needs. Monthly billing offers premium features with the flexibility to pay month by month and cancel whenever needed.",
          },
          {
            title: "Billing Options",
            text:
              "Choose how you would like to be billed for your subscription.",
            bullets: ["Monthly Billing", "Annual Billing (Save 17%)"],
            note:
              "Benefits — low monthly payment, no long-term commitment, flexible subscription management, and upgrade or cancel anytime.",
          },
          {
            title: "Membership Plans",
            text:
              "Three plans scale from exploring the platform to full financial planning.",
            bullets: [
              {
                label: "Free",
                text:
                  "Limited access to RN salaries and cost-of-living data, up to 10 salary results, compare one city and one role at a time, community access and a prefilled city-specific retirement calculator. Best for new users exploring before upgrading.",
              },
              {
                label: "Pro — $2.99/month",
                text:
                  "Cost-of-living filters, investment planning tools, nursing job market data, leftover income projections and salary comparison; compare unlimited cities and calculate real take-home pay. Best for nurses who want premium features with monthly flexibility.",
              },
              {
                label: "Pro + Newsletter — $4.99/month",
                text:
                  "Everything in Pro plus the weekly MapMyPay Insider newsletter and curated weekly nursing job listings by email. A Current Plan badge marks your active subscription.",
              },
            ],
          },
          {
            title: "Platform Highlights",
            text: "The page showcases the scale and reliability of MapMyPay.",
            bullets: [
              {
                label: "9,000+ Nurses",
                text:
                  "A growing community of healthcare professionals using MapMyPay.",
              },
              {
                label: "21,000+ U.S. Cities",
                text:
                  "Comprehensive salary and affordability data covering thousands of cities nationwide.",
              },
              {
                label: "Updated Weekly",
                text:
                  "Salary, housing and financial data are refreshed regularly to provide accurate insights.",
              },
            ],
            note:
              "Why it matters — make confident career and relocation decisions using current and reliable financial data.",
          },
          {
            title: "Frequently Asked Questions (FAQ)",
            text: "Common questions about subscriptions and billing:",
            bullets: [
              "Can I cancel my subscription anytime?",
              "What happens after my free trial?",
              "What is the difference between Pro and Pro + Newsletter?",
              "Will my existing subscription remain unchanged?",
              "How is take-home pay calculated?",
            ],
            note:
              "Benefit — quick answers help you understand subscription options before making a purchase.",
          },
          {
            title: "Why Choose Monthly Billing?",
            text:
              "Monthly billing is designed for users who want premium features with maximum flexibility and minimal commitment.",
            bullets: [
              "Affordable monthly pricing",
              "No annual commitment",
              "Cancel anytime",
              "Full access to premium salary and affordability tools",
              "Unlimited city comparisons",
              "Easy upgrade to annual billing whenever you choose",
            ],
          },
        ],
        tip:
          "Prefer flexibility? Monthly billing gives you full Pro access with no commitment — switch to Annual any time to save 17%.",
      },
    ],
    steps: [],
    tip: "",
  },

  "contact-us": {
    cat: "profile",
    title: "Contact Us",
    readTime: "3 min read",
    updated: "Jul 2026",
    image: imgContactUs,
    darkImage: imgContactUsDark,
    desc:
      "The Contact Us page provides a simple and convenient way for users to get in touch with the MapMyPay support team. Whether you have questions about your account, subscription, salary calculations, or need technical assistance, you can submit your inquiry directly through the contact form.",
    stepsTitle: "What’s on the Contact Us page",
    steps: [
      {
        title: "Purpose",
        text:
          "The Contact Us page lets you communicate with the support team by sending messages directly from within the application — so you can reach out for assistance without leaving the platform.",
      },
      {
        title: "Support Email",
        text:
          "A dedicated support email — support@mapmypay.com — is shown for users who prefer to contact the team directly.",
        bullets: [
          "Contact support directly from your email client",
          "Ideal for detailed inquiries or follow-up conversations",
          "Convenient alternative to using the contact form",
        ],
      },
      {
        title: "Contact Form",
        text:
          "The contact form lets you submit questions, feedback or support requests directly through the platform — a quick and organized way to reach the support team.",
        bullets: [
          {
            label: "Name",
            text:
              "Enter your full name so the team can identify you and personalize their response.",
          },
          {
            label: "Email Address",
            text:
              "A valid email address where you can receive replies, status updates and follow-ups. Always provide an active address.",
          },
          {
            label: "Message",
            text:
              "Describe your question, issue or feedback in detail so the team has what it needs to understand and resolve your request.",
          },
          {
            label: "Send",
            text:
              "Click Send to submit your inquiry securely to the MapMyPay support team.",
          },
        ],
      },
      {
        title: "Message Best Practices",
        text: "Include relevant details in your message:",
        bullets: [
          "Account-related questions",
          "Subscription or billing concerns",
          "Salary calculation inquiries",
          "Technical issues or bugs",
          "Feature requests",
          "General feedback",
        ],
        note:
          "Benefit — detailed information reduces response times and lets the support team assist you more efficiently.",
      },
      {
        title: "What Happens Next",
        text: "Once your message is submitted:",
        bullets: [
          "Your request is sent to the support team.",
          "A confirmation may be displayed indicating successful submission.",
          "The team reviews your inquiry and responds via the email address you provided.",
        ],
      },
      {
        title: "Tips for Faster Support",
        text: "To help the support team resolve your issue more quickly:",
        bullets: [
          "Use a valid email address.",
          "Clearly describe your question or issue.",
          "Include relevant details, such as your subscription plan or the city you were searching.",
          "Mention any error messages you encountered.",
        ],
      },
      {
        title: "Why Use the Contact Form?",
        text: "A secure and reliable way to reach the MapMyPay support team.",
        bullets: [
          "Easy-to-use contact form",
          "Direct communication with support",
          "Quick submission of questions and feedback",
          "Personalized responses via email",
          "Centralized support for account, billing and technical inquiries",
        ],
      },
    ],
    tip:
      "Include your plan and the city or role you were viewing when you hit an issue — it helps support resolve it on the first reply.",
  },

  referral: {
    cat: "profile",
    title: "Referral Program",
    readTime: "4 min read",
    updated: "Jul 2026",
    image: imgReferral,
    darkImage: imgReferralDark,
    desc:
      "The Referral Program allows users to invite friends to join MapMyPay and earn rewards when those referrals purchase a qualifying subscription. Users can easily share their unique referral link or QR code through multiple channels and track referral activity from a centralized dashboard.",
    stepsTitle: "What’s on the Referral page",
    steps: [
      {
        title: "Purpose",
        text:
          "The Referral page makes it simple to share MapMyPay with friends while rewarding you for successful referrals. Each successful referral that results in a paid subscription earns you a free month of the Pro plan.",
      },
      {
        title: "Referral Reward",
        text:
          "Invite friends and earn premium benefits when they subscribe — get one free month of MapMyPay Pro for every friend who purchases a qualifying paid plan using your referral link.",
        bullets: [
          "Earn free Pro membership",
          "Unlimited referral opportunities",
          "Simple sharing process",
          "Automatic reward processing after successful payment",
        ],
      },
      {
        title: "Referral Link",
        text:
          "Each user receives a unique referral link to share. It tracks referrals and ensures rewards are credited to the correct account.",
        bullets: [
          "Unique for every user",
          "Easy to copy and share",
          "Automatically tracks successful referrals",
        ],
      },
      {
        title: "QR Code",
        text:
          "A unique QR code is generated alongside the referral link, letting friends quickly access the registration page by scanning it with their mobile device.",
        bullets: [
          "Faster sharing",
          "Mobile-friendly experience",
          "No need to manually type the referral URL",
        ],
      },
      {
        title: "Copy Link",
        text:
          "The Copy Link button instantly copies your referral URL to the clipboard, making it easy to share across messaging apps, email or social media.",
        bullets: ["One-click copy", "Quick sharing", "Reduces typing errors"],
      },
      {
        title: "Share Your Referral",
        text: "Share your referral link using popular communication channels.",
        bullets: ["Facebook", "X (formerly Twitter)", "LinkedIn", "Email"],
        note:
          "Benefit — reach friends across multiple platforms and share directly without copying links manually.",
      },
      {
        title: "How It Works",
        text: "The referral process is simple and transparent.",
        bullets: [
          {
            label: "Step 1 – Share Your Referral Link",
            text:
              "Send your personalized referral link or QR code to friends, family or colleagues.",
          },
          {
            label: "Step 2 – Your Friend Purchases a Paid Plan",
            text:
              "Your friend signs up using your referral link and subscribes to an eligible paid membership plan.",
          },
          {
            label: "Step 3 – Receive Your Reward",
            text:
              "Once your friend’s payment is confirmed, one free month of the Pro plan is automatically added to your account.",
          },
        ],
        note:
          "Why it matters — the process rewards you for helping grow the MapMyPay community while giving new members access to valuable salary and financial-planning tools.",
      },
      {
        title: "Referral Progress",
        text:
          "A real-time overview of your referral activity and earned rewards.",
        bullets: [
          {
            label: "Total Referrals",
            text:
              "The total number of friends who have registered using your referral link.",
          },
          {
            label: "Pending Referrals",
            text:
              "Referrals awaiting subscription confirmation or payment completion.",
          },
          {
            label: "Free Pro Months Earned",
            text:
              "The total number of free Pro months you have earned through successful referrals.",
          },
          {
            label: "Subscribed Referrals",
            text:
              "The number of referred users who have successfully purchased a qualifying subscription.",
          },
        ],
        note:
          "Benefit — monitor referral performance, track pending rewards and measure referral success over time.",
      },
      {
        title: "Reward Eligibility",
        text: "To receive referral rewards:",
        bullets: [
          "Your friend must register using your unique referral link or QR code.",
          "The referred user must purchase an eligible paid subscription.",
          "Rewards are applied after the payment has been successfully confirmed.",
        ],
      },
      {
        title: "Why Use the Referral Program?",
        text:
          "Extend the benefits of MapMyPay to others while earning valuable subscription rewards.",
        bullets: [
          "Earn free months of Pro membership",
          "Simple referral process",
          "Share via link, QR code or social media",
          "Automatic referral tracking",
          "Real-time referral progress dashboard",
          "Rewarded for every successful qualifying referral",
        ],
      },
    ],
    tip:
      "Every friend who subscribes on a paid plan through your link earns you a free month of Pro — there’s no limit on how many you can earn.",
  },

  "change-password": {
    cat: "profile",
    title: "Change Password",
    readTime: "3 min read",
    updated: "Jul 2026",
    image: imgChangePassword,
    darkImage: imgChangePasswordDark,
    desc:
      "The Change Password feature allows users to securely update their account password at any time. Changing your password regularly helps protect your account and ensures that only authorized users have access to your personal information and subscription.",
    stepsTitle: "What’s in the Change Password dialog",
    steps: [
      {
        title: "Purpose",
        text:
          "The Change Password dialog lets you replace your current password with a new one through a secure verification process.",
      },
      {
        title: "Old Password",
        text:
          "Enter your current account password to verify your identity before any password changes.",
        bullets: [
          "Confirms account ownership",
          "Prevents unauthorized password changes",
          "Adds an extra layer of account security",
        ],
        note:
          "Note — you must enter your existing password correctly before creating a new one.",
      },
      {
        title: "New Password",
        text: "Enter the password you want to use for future logins.",
        bullets: [
          "At least 8 characters",
          "Uppercase and lowercase letters",
          "Numbers",
          "Special characters (recommended)",
        ],
        note:
          "Benefit — a strong new password improves security and helps protect your personal information.",
      },
      {
        title: "Confirm Password",
        text:
          "Re-enter your new password to confirm it and catch typing mistakes.",
        bullets: [
          "Prevents typing mistakes",
          "Confirms password accuracy",
          "Reduces login issues after updating",
        ],
        note:
          "Note — the confirmation password must exactly match the new password.",
      },
      {
        title: "Show/Hide Password",
        text:
          "Each password field includes a visibility toggle to show or hide the password while typing.",
        bullets: [
          "Verify your password before submitting",
          "Reduce typing errors",
          "Improve usability without compromising security",
        ],
      },
      {
        title: "Save Changes",
        text:
          "Click Save Changes to validate your information and securely update your account password. After a successful update:",
        bullets: [
          "Your new password becomes active immediately.",
          "Future logins must use the new password.",
          "A confirmation message may indicate the password was updated successfully.",
        ],
      },
      {
        title: "Password Requirements",
        text: "For the best security, your password should:",
        bullets: [
          "Be at least 8 characters long",
          "Include uppercase and lowercase letters",
          "Include at least one number",
          "Include a special character when possible",
          "Avoid common words or easily guessed information",
        ],
        note:
          "Why it matters — a strong password protects your account from unauthorized access and enhances the overall security of your personal and subscription information.",
      },
      {
        title: "Why Change Your Password?",
        text:
          "Updating your password periodically helps maintain the security of your MapMyPay account.",
        bullets: [
          "Strengthens account protection",
          "Prevents unauthorized access",
          "Keeps your personal information secure",
          "Ensures only you can access your account",
          "Supports a safer and more secure user experience",
        ],
      },
    ],
    tip:
      "Never reuse a password from another site, and update it periodically to keep your account secure.",
  },
};

const POPULAR = [
  { label: "Salaries & Paychecks", id: "salary-paycheck" },
  { label: "Mortgage Calculator", id: "mortgage-how" },
  { label: "Comparison", id: "compare-cities" },
  { label: "Search Cities", id: "city-filters" },
  { label: "Jobs", id: "job-search" },
];

const articleMatches = (item, q) =>
  item.title.toLowerCase().includes(q) ||
  ARTICLES[item.id].desc.toLowerCase().includes(q);

const normalizeBullets = (bullets) =>
  (bullets || []).map((b) =>
    typeof b === "string" ? { label: "", text: b } : b,
  );

const StepList = ({ steps }) => (
  <div className="app-guide-steps">
    {steps.map((step, i) => (
      <div className="app-guide-step" key={i}>
        <div className="app-guide-step__num">{i + 1}</div>
        <div className="app-guide-step__body">
          <div className="app-guide-step__title">{step.title}</div>
          {step.text && <div className="app-guide-step__text">{step.text}</div>}
          {!!(step.bullets && step.bullets.length) && (
            <ul className="app-guide-step__bullets">
              {normalizeBullets(step.bullets).map((b, bi) => (
                <li key={bi}>
                  {b.label && <strong>{b.label}</strong>}
                  {b.label && " — "}
                  {b.text}
                </li>
              ))}
            </ul>
          )}
          {step.note && <div className="app-guide-step__note">{step.note}</div>}
        </div>
      </div>
    ))}
  </div>
);

const TipBanner = ({ tip }) => (
  <div className="app-guide-tip">
    <TipIcon />
    <div>
      <strong>Tip&nbsp;·&nbsp;</strong>
      {tip}
    </div>
  </div>
);

const AppGuide = () => {
  const { resolvedTheme } = useTheme();
  const mainRef = useRef(null);

  const [open, setOpen] = useState({ "getting-started": true });
  const [active, setActive] = useState("nav-dashboard");
  const [query, setQuery] = useState("");
  const [kbMenuOpen, setKbMenuOpen] = useState(false);

  const select = (id) => {
    const cat = CATS.find((c) => c.items.some((i) => i.id === id));
    setOpen((s) => (cat ? { ...s, [cat.id]: true } : s));
    setActive(id);
    setKbMenuOpen(false);
    if (mainRef.current) {
      mainRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const toggleCat = (id) => setOpen((s) => ({ ...s, [id]: !s[id] }));

  const q = query.trim().toLowerCase();
  const active_ = ARTICLES[active] || ARTICLES["nav-dashboard"];
  const activeCat = active_.cat;

  const cats = useMemo(() => {
    return CATS.map((cat) => {
      const items = cat.items.filter((i) => !q || articleMatches(i, q));
      const inCat = !q && cat.id === activeCat;
      const subDefs =
        cat.id === "profile"
          ? items.filter((i) => i.id !== "profile-page")
          : [];
      const hasSub = subDefs.length > 0;
      const expanded = hasSub && (!!open[cat.id] || !!q);
      const headerActive = inCat && (!hasSub || active === "profile-page");
      return {
        id: cat.id,
        name: cat.name,
        hasSub,
        expanded,
        headerActive,
        go: hasSub
          ? () => {
              const willOpen = !open[cat.id];
              setOpen((s) => ({ ...s, [cat.id]: willOpen }));
              if (willOpen) {
                setActive("profile-page");
                if (mainRef.current) {
                  mainRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }
              }
            }
          : () => select((items[0] || cat.items[0]).id),
        subItems: subDefs.map((it) => ({
          id: it.id,
          title: it.title,
          active: !q && active === it.id,
          go: () => select(it.id),
        })),
      };
    }).filter(
      (c) =>
        !q ||
        CATS.find((d) => d.id === c.id).items.some((i) => articleMatches(i, q)),
    );
  }, [q, open, active, activeCat]);

  const noResults = q.length > 0 && cats.length === 0;

  const order = CATS;
  const ci = order.findIndex((c) => c.id === activeCat);
  const prevCat = ci > 0 ? order[ci - 1] : null;
  const nextCat = ci >= 0 && ci < order.length - 1 ? order[ci + 1] : null;
  const prev = prevCat
    ? { title: prevCat.name, go: () => select(prevCat.items[0].id) }
    : null;
  const next = nextCat
    ? { title: nextCat.name, go: () => select(nextCat.items[0].id) }
    : null;

  const article = active_;
  const hasBlocks = !!article.blocks;
  const noImage = !article.image && !article.blocks;
  const articleImage =
    (resolvedTheme === "dark" && article.darkImage) || article.image;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(activityStart({ page_name: "APP_GUIDE", platform: "web" }));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(activityEnd({ page_name: "APP_GUIDE" }));
    };
  }, [dispatch]);

  usePageTracking("APP_GUIDE");
  return (
    <div className="app-guide-page">
      <button
        type="button"
        className="app-guide-kb-trigger"
        onClick={() => setKbMenuOpen(true)}
        aria-label="Open Knowledge Base menu"
      >
        <MenuIcon />
      </button>

      <div className="app-guide-hero">
        <div className="app-guide-hero__eyebrow">
          <KbIcon />
          KNOWLEDGE BASE
        </div>

        <div className="app-guide-popular">
          <span>Popular:</span>
          {POPULAR.map((p) => (
            <button
              type="button"
              key={p.id}
              onClick={() => {
                setQuery("");
                select(p.id);
              }}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      <div className="app-guide-body">
        {kbMenuOpen && (
          <div
            className="app-guide-kb-overlay"
            onClick={() => setKbMenuOpen(false)}
          />
        )}

        <aside className={`app-guide-sidebar${kbMenuOpen ? " is-open" : ""}`}>
          <div className="app-guide-sidebar__header">
            <div className="app-guide-sidebar__title">KNOWLEDGE BASE</div>
            <button
              type="button"
              className="app-guide-kb-close"
              onClick={() => setKbMenuOpen(false)}
              aria-label="Close menu"
            >
              <CloseIcon />
            </button>
          </div>
          {cats.map((cat) => (
            <React.Fragment key={cat.id}>
              <button
                type="button"
                className={`app-guide-cat-row${
                  cat.headerActive ? " is-active" : ""
                }`}
                onClick={cat.go}
              >
                <span>{cat.name}</span>
                {cat.hasSub && <ChevronIcon open={cat.expanded} />}
              </button>
              {cat.hasSub && cat.expanded && (
                <div className="app-guide-subnav">
                  {cat.subItems.map((sub) => (
                    <button
                      type="button"
                      key={sub.id}
                      className={sub.active ? "is-active" : ""}
                      onClick={sub.go}
                    >
                      {sub.title}
                    </button>
                  ))}
                </div>
              )}
            </React.Fragment>
          ))}
          {noResults && (
            <div className="app-guide-noresults">
              No articles match “{query}”.
            </div>
          )}
        </aside>

        <main className="app-guide-main" ref={mainRef}>
          <article className="app-guide-article">
            <h2>{article.title}</h2>
            <p className="app-guide-article__desc">{article.desc}</p>
            <div className="app-guide-divider"></div>

            {!hasBlocks && (
              <>
                {article.image && (
                  <div className="app-guide-media">
                    <img
                      src={articleImage}
                      alt={article.title}
                      width={imageDims(articleImage)[0]}
                      height={imageDims(articleImage)[1]}
                    />
                  </div>
                )}
                {noImage && (
                  <div className="app-guide-media app-guide-media--empty">
                    <EmptyMediaIcon />
                    <div className="app-guide-media__label">
                      {article.dropLabel}
                    </div>
                  </div>
                )}

                {article.stepsTitle && (
                  <h3 className="app-guide-steps-title">
                    {article.stepsTitle}
                  </h3>
                )}
                <StepList steps={article.steps} />
                {article.tip && <TipBanner tip={article.tip} />}
              </>
            )}

            {hasBlocks && (
              <div className="app-guide-blocks">
                {article.blocks.map((blk, bi) => {
                  const blkImage =
                    (resolvedTheme === "dark" && blk.darkImage) || blk.image;
                  return (
                    <section key={bi}>
                      <div className="app-guide-block__head">
                        <span className="app-guide-block__num">{bi + 1}</span>
                        <h3>{blk.heading}</h3>
                      </div>
                      <p className="app-guide-block__desc">{blk.desc}</p>
                      <div className="app-guide-media">
                        <img
                          src={blkImage}
                          alt={blk.heading}
                          width={imageDims(blkImage)[0]}
                          height={imageDims(blkImage)[1]}
                        />
                      </div>
                      <StepList steps={blk.steps} />
                      {blk.tip && <TipBanner tip={blk.tip} />}
                    </section>
                  );
                })}
              </div>
            )}
          </article>

          <div className="app-guide-pager">
            {prev ? (
              <button
                type="button"
                className="app-guide-pager__btn is-prev"
                onClick={prev.go}
              >
                <ArrowLeftIcon />
                <span>
                  <small>PREVIOUS</small>
                  <em>{prev.title}</em>
                </span>
              </button>
            ) : (
              next && <span></span>
            )}
            {next && (
              <button
                type="button"
                className="app-guide-pager__btn is-next"
                onClick={next.go}
              >
                <span>
                  <small>NEXT</small>
                  <em>{next.title}</em>
                </span>
                <ArrowRightIcon />
              </button>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppGuide;
